import React from 'react';
import { RouterProvider } from 'react-router-dom';

import './App.css';
import rootRouter from './root.routes';
import { AuthenticationContextProvider } from './shared/context/authentication/authentication.context';
import { CssBaseline, ThemeProvider } from '@mui/material';
import MuiThemeLight from './shared/styles/mui/themes/mui-theme-Light';
import { AppStoreContextProvider } from './shared/context/app-store/app-store.context';

function App() {
  return (<>



    {/* Authentication-ContextProvider */}
    <AuthenticationContextProvider>

      {/* AppStore-ContextProvider */}
      <AppStoreContextProvider>

        <ThemeProvider theme={MuiThemeLight}>

          {/* enableColorScheme <-- sets the scrollbar to dark/light mode based on the current theme mode */}
          <CssBaseline enableColorScheme />

          {/* Route-ContextProvider*/}
          <RouterProvider router={rootRouter} />

        </ThemeProvider>

      </AppStoreContextProvider>

    </AuthenticationContextProvider >
  </>);
}
export default App;
